if (!customElements.get('collection-subcollections-slider')) {
  customElements.define(
    'collection-subcollections-slider',
    class CollectionSubcollectionsSlider extends HTMLElement {
      connectedCallback() {
        this.swiperRoot = this.querySelector('.collection-subcollections__swiper');
        if (!this.swiperRoot || typeof window.FoxTheme === 'undefined' || !window.FoxTheme.Carousel) {
          return;
        }

        this.nextEl = this.querySelector('.swiper-button-next');
        this.prevEl = this.querySelector('.swiper-button-prev');
        this.swiperWrap = this.querySelector('.collection-subcollections__swiper-wrap');

        this.options = {
          slidesPerView: 'auto',
          spaceBetween: 10,
          watchOverflow: true,
          threshold: 2,
          grabCursor: true,
          navigation:
            this.nextEl && this.prevEl
              ? {
                  nextEl: this.nextEl,
                  prevEl: this.prevEl,
                }
              : false,
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.swiperRoot, this.options);
        this.sliderInstance.init();

        this._boundNavVisibility = this.updateNavVisibility.bind(this);
        window.addEventListener('resize', this._boundNavVisibility);

        if (this.swiperWrap && typeof ResizeObserver !== 'undefined') {
          this._resizeObserver = new ResizeObserver(() => this.updateNavVisibility());
          this._resizeObserver.observe(this.swiperWrap);
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.updateNavVisibility());
        });

        if (typeof FoxTheme !== 'undefined' && FoxTheme.a11y && FoxTheme.a11y.getFocusableElements) {
          FoxTheme.a11y.getFocusableElements(this).forEach((element) => {
            element.addEventListener('focusin', () => {
              const slide = element.closest('.swiper-slide');
              if (!slide || !this.sliderInstance.slider) return;
              this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
            });
          });
        }
      }

      updateNavVisibility() {
        const inst = this.sliderInstance?.slider;
        const wrap = this.swiperWrap;
        if (!inst || !wrap || !inst.wrapperEl) return;

        requestAnimationFrame(() => {
          const slideWidth = inst.wrapperEl.scrollWidth;
          const viewWidth = wrap.clientWidth;
          const tolerance = 6;
          const hideNav = slideWidth <= viewWidth + tolerance;
          this.classList.toggle('collection-subcollections--nav-hidden', hideNav);
          if (typeof inst.allowTouchMove === 'boolean') {
            inst.allowTouchMove = !hideNav;
          }
        });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._boundNavVisibility);
        if (this._resizeObserver) {
          this._resizeObserver.disconnect();
          this._resizeObserver = null;
        }
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy(true, true);
          this.sliderInstance = null;
        }
      }
    }
  );
}
